'use strict';

var hasSymbols = require('has-symbols/shams');

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/has-tostringtag@1.0.2/~/has-tostringtag/shams.js
// module id = 730
// module chunks = 0